import { FC, useState, ChangeEvent, KeyboardEvent, useEffect, } from "react";
import { Fade } from "react-awesome-reveal";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Block from "../components/Block.component";
import DeviceConfig from "../config/Device.config";
import Device from "../interfaces/Device.interface";
import colors from "../config/Colors.config";
import { Button, Card, CardBody, CardHeader, Col, DropdownItem, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { Badge, FormControl, FormGroup, IconButton, InputLabel } from "@mui/material";
import { AccountBoxOutlined, Add, ArrowBack, Article, AssignmentOutlined, AttachMoneyOutlined, AutoDeleteOutlined, Cached, CalendarTodayOutlined, Chat, Close, CloseFullscreen, CreditCard, DeleteOutlineOutlined, DownloadOutlined, EditCalendarOutlined, ErrorOutlined, Groups2Outlined, InfoOutlined, LocationOn, Map, PaymentOutlined, PersonOutlined, PersonOutlineOutlined, Phone, PostAddOutlined, PriceCheckOutlined, RecommendOutlined, SaveOutlined, Search, Transgender, WarningAmberOutlined } from "@mui/icons-material";
import ClienteService from "../services/Cliente.service";
import Response from "../interfaces/Response.interface";
import Cte from "../interfaces/Cte.interface";
import DataTable, { TableColumn } from "react-data-table-component";
import Ubicacion from "../interfaces/Ubicacion.interface";
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";
import TiempoTool from "../tools/Tiempo.tool";
import SolicitudCredito from "../interfaces/SolicitudCredito.interface";
import SolicitudCreditoModel from "../models/SolicitudCredito.model";
import SolicitudCreditoService from "../services/SolicitudCredito.service";
import Numero from "../tools/Numero.tool";
import FechaTool from "../tools/Fecha.tool";

import imgMapa from "../assets/img/mapa.png";
import icoPDF from "../assets/icon/iconPdf.png";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import SolicitudCreditoPdf from "../reports/SolicitudCredito.report";
import OperacionesService from "../services/Operacion.service";
import Valor from "../interfaces/Valor.interface";
import { toast, ToastContainer } from "react-toastify";
import Cliente from "../interfaces/Cliente.interface";
import ClienteModel from "../models/Cliente.model";
import SelectStyle from "../assets/styles/Select.style";
import Usuario from "../interfaces/Usuario.interface";

let lastClickTime = 0;
interface Value { Id: number, value: string }

const ClienteBuscar: FC<{ changeIndexPage: any, usuario: Usuario }> = ({ changeIndexPage, usuario }) => {

    const objectSolicitud: SolicitudCredito = SolicitudCreditoModel.getEstructura();
    const objectCliente: Cliente = ClienteModel.getEstructura();

    const [data] = useState<Device>(DeviceConfig.data());

    const [ubicacion, setUbicacion] = useState<Ubicacion | null>(null);

    const [arrayCliente, setArrayCliente] = useState<Cte[]>([])
    const [cliente, setCliente] = useState<Cte>();

    const [isOpenModalMapa, setIsOpenModalMapa] = useState<boolean>(false);

    const [texto, setTexto] = useState<string>("");
    const [modal, setModal] = useState<string>("Cliente");

    const [isOpenModalSolicitud, setIsOpenModalSolicitud] = useState<boolean>(false);

    const [arraySolicitudCredito, setArraysolicitudCredito] = useState<SolicitudCredito[]>([]);
    const [solicitudCredito, setSolicitudCredito] = useState<SolicitudCredito>(objectSolicitud);
    const [isOpenModalEliniarSolicitud, setIsOpenModalEliniarSolicitud] = useState<boolean>(false);
    const [isOpenModelPDF, setIsOpenModalPDF] = useState<boolean>(false);

    const [operacionesNumeros, setOperacionesNumeros] = useState<Valor[]>([]);
    const [operacionesMontos, setOperacionesMontos] = useState<Valor[]>([]);
    const [operacionesFrecuencias, setOperacionesFrecuencias] = useState<Valor[]>([]);

    const [isOpenModalSolicitudError, setIsOpenModalSolicitudError] = useState<boolean>(false);
    const [indexDatoFaltanteSolicitud, setIndexFaltanteSolicitud] = useState<{ index: string, value: boolean }[]>([]);

    const [clienteData, setClienteData] = useState<Cliente>(objectCliente);

    const [arrayTipo, setArrayTipo] = useState<Value[]>([]);
    const [arrayStatus, setArrayStatus] = useState<Value[]>([]);
    const [arrayMonto, setArrayMonto] = useState<Value[]>([]);
    const [arrayPlazo, setArrayPlazo] = useState<Value[]>([]);
    const [arrayFormaPago, setArrayFormaPago] = useState<Value[]>([]);

    const navigate = useNavigate();

    useEffect(() => {
        clientesListar();
        operacionesListar();
        cargarCatalogoSolicitudCredito();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cargarCatalogoSolicitudCredito = async (): Promise<void> => {
        const response: Response = await SolicitudCreditoService.listarCatalogo();
        if (response.error === false) {
            const arrayTipo: Value[] = response.data.value.arraySolicitudCreditoTipo ?? [];
            const arrayStatus: Value[] = response.data.value.arraySolicitudCreditoStatus ?? [];
            const arrayMonto: Value[] = response.data.value.arraySolicitudCreditoMonto ?? [];
            const arrayPlazo: Value[] = response.data.value.arraySolicitudCreditoPlazo ?? [];
            const arrayFormaPago: Value[] = response.data.value.arraySolicitudCreditoFormaPago ?? [];
            setArrayTipo(arrayTipo);
            setArrayStatus(arrayStatus);
            setArrayMonto(arrayMonto);
            setArrayPlazo(arrayPlazo);
            setArrayFormaPago(arrayFormaPago);
        }
    };

    const operacionesListar = async (): Promise<void> => {
        const response: Response = await OperacionesService.listar();
        if (response.error === false) {
            const operacionesNumeros: Valor[] = response.data.value.operacionesNumeros;
            const operacionesMontos: Valor[] = response.data.value.operacionesMontos;
            const operacionesFrecuencias: Valor[] = response.data.value.operacionesFrecuencias;
            setOperacionesNumeros(operacionesNumeros);
            setOperacionesMontos(operacionesMontos);
            setOperacionesFrecuencias(operacionesFrecuencias);
        }
    };

    const clientesListar = async (): Promise<void> => {
        const response: Response = await ClienteService.listar(texto);
        if (response.error === false) {
            const arrayCliente: Cte[] = response.data.value ?? [];            
            setArrayCliente(arrayCliente);
        }
    }

    const solicitudCreditoListar = async (IdCliente: number): Promise<void> => {
        const response: Response = await SolicitudCreditoService.listar(IdCliente);
        if (response.data.error === false) {
            let arraySolicitudCredito: SolicitudCredito[] = response.data.value ?? [];
            setArraysolicitudCredito(arraySolicitudCredito);
        }
    };

    const calcularEdad = (fechaNacimiento: string): number => {
        const hoy = new Date();
        const nacimiento = new Date(fechaNacimiento);

        let edad = hoy.getFullYear() - nacimiento.getFullYear();

        const mes = hoy.getMonth() - nacimiento.getMonth();

        // Si aún no ha cumplido años este año, restar 1
        if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
            edad--;
        }

        return edad;
    }

    const verDatosCliente = async (row: Cte): Promise<void> => {
        await navigate(`/dashboard/?page=${1}&cliente=${row.IdCliente}`);
        await TiempoTool.sleep(0.5)
        await changeIndexPage(1, row.IdCliente);
    }

    const solicitudCreditoEliminar = async (): Promise<void> => {
        await SolicitudCreditoService.eliminar(solicitudCredito.IdSolicitudCredito);
        solicitudCreditoListar(cliente?.IdCliente ?? 0);
        setIsOpenModalEliniarSolicitud(false);
        setIsOpenModalSolicitud(false)
        toast.info("Solicitud de Credito Eliminada");
        clientesListar();
    };

    const solicitudCreditoValidar = (): boolean => {

        let value: boolean = true;

        const { tipo: { IdTipo }, monto: { IdMonto }, plazo: { IdPlazo }, formaPago: { IdFormaPago }, status: { IdStatus }, } = solicitudCredito        
        if (Number(IdTipo) === 0) { setIndexFaltanteSolicitud(prev => [...prev, { index: "IdTipo", value: true }]); value = false; }
        if (Number(IdMonto) === 0) { setIndexFaltanteSolicitud(prev => [...prev, { index: "IdMonto", value: true }]); value = false; }
        if (Number(IdPlazo) === 0) { setIndexFaltanteSolicitud(prev => [...prev, { index: "IdPlazo", value: true }]); value = false; }
        if (Number(IdFormaPago) === 0) { setIndexFaltanteSolicitud(prev => [...prev, { index: "IdFormaPago", value: true }]); value = false; }
        if (Number(IdStatus) === 0) { setIndexFaltanteSolicitud(prev => [...prev, { index: "IdStatus", value: true }]); value = false; }        
        return value

    }

    const solicitudCreditoGuardar = async (): Promise<void> => {
        setIndexFaltanteSolicitud([]);
        const value: boolean = solicitudCreditoValidar();

        if (value) {
            const response: Response = await SolicitudCreditoService.guardar({ ...solicitudCredito, usuario: { IdUsuario: usuario.IdUsuario, nombre: usuario.nombreCompleto } });
            if (response.error === false) {
                toast.success("Solicitud de credito guardada");
                solicitudCreditoListar(cliente?.IdCliente ?? 0);
                setSolicitudCredito(response.data.value)
                // setIsOpenModalSolicitud(false);
                clientesListar();
            }
        } else {
            setIsOpenModalSolicitudError(true);
        }

    }

    const columnasCliente: TableColumn<Cte>[] = [
        {
            name: <Label style={{ fontSize: 15, fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <PersonOutlined /> Nombre Completo</Label>,
            cell: (cliente: Cte) => (
                <Label style={{ fontSize: 14, cursor: "pointer", fontWeight: "bold" }} onDoubleClick={() => verDatosCliente(cliente)} >
                    {cliente.nombres} {cliente.paterno} {cliente.materno}
                </Label>
            ),
            width: "20%"
        },
        {
            name: <Label style={{ fontSize: 15, fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <Transgender /> Genero</Label>,
            cell: (cliente: Cte) => (
                <Label style={{ fontSize: 14, cursor: "pointer" }} onDoubleClick={() => verDatosCliente(cliente)} >
                    {cliente.genero}
                </Label>
            ),
            width: "100px"
        },
        {
            name: <Label style={{ fontSize: 15, fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <CalendarTodayOutlined /> Edad</Label>,
            cell: (cliente: Cte) => (
                <Label style={{ fontSize: 14, cursor: "pointer" }} onDoubleClick={() => verDatosCliente(cliente)}>
                    {calcularEdad(cliente.fechaNacimiento)} años
                </Label>
            ),
        },

        {
            name: <Label style={{ fontSize: 15, fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <Phone /> Telefono</Label>,
            cell: (cliente: Cte) => (
                <Label style={{ fontSize: 14, cursor: "pointer" }} onDoubleClick={() => verDatosCliente(cliente)} >
                    {cliente.telefono} {cliente.numeroSolicitudes}
                </Label>
            ),
            width: "150px"
        },
        {
            name: <Label style={{ fontSize: 15, fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <LocationOn /> Direccion</Label>,
            cell: (cliente: Cte) => (
                <Label style={{ fontSize: 14, cursor: "pointer" }} onDoubleClick={() => verDatosCliente(cliente)}>
                    {cliente.direccion}, {cliente.recidencia}, {cliente.ciudad}, {cliente.estado}, {cliente.pais}
                </Label>
            ),
            width: "40%"
        },

        {
            name: <Label style={{ fontSize: 15, fontWeight: "bold" }} ></Label>,
            cell: (cliente: Cte) => (
                <>
                    <IconButton
                        style={{ boxShadow: "none", color: "#EC0000" }}
                        onClick={() => {
                            setIsOpenModalMapa(true);
                            setUbicacion({
                                latitud: Number(cliente.latitud),
                                longitud: Number(cliente.longitud)
                            });
                        }}
                    >
                        <LocationOn />
                    </IconButton>
                    <IconButton
                        style={{ boxShadow: "none", color: colors.secundario }}
                        onClick={() => {
                            setIsOpenModalSolicitud(true);
                            setCliente(cliente);
                            setModal("Cliente");
                        }}
                        data-tooltip-id={`badge-${cliente?.IdCliente}`}
                    >
                        <Badge badgeContent={cliente.numeroSolicitudes}                                                >
                            <Article style={{ color: colors.secundario }} />
                        </Badge>
                        <Tooltip

                            id={`badge-${cliente?.IdCliente}`}
                            place="right-start"
                        >
                            <p style={{ fontSize: 14 }} >
                                {
                                    cliente.numeroSolicitudes === 0
                                        ? "Este cliente no tiene solicitudes de crédito"
                                        : `Este cliente tiene ${cliente.numeroSolicitudes} ${cliente.numeroSolicitudes === 1 ? "solicitud" : "solicitudes"
                                        } de crédito`
                                }
                            </p>
                        </Tooltip>
                    </IconButton>
                </>
            ),
        },
    ];

    const columnaSolicitudCredito: TableColumn<SolicitudCredito>[] = [
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <PersonOutlineOutlined /> Tipo </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer", fontWeight: "bold" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    {solicitudCredito.tipo.value}
                </Label>,
            width: "150px"
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <CalendarTodayOutlined /> Fecha </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    {FechaTool.formato(solicitudCredito.fechaCreacion)}, {TiempoTool.convertTimeTo12HourFormat(solicitudCredito.horaCreacion)}
                </Label>,
            width: "150px"
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <AccountBoxOutlined /> Asesor </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer", fontWeight: "bold" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    {solicitudCredito.usuario.nombre}
                </Label>,
            width: "150px"
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <InfoOutlined /> Estatus </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer", fontWeight: "bold" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    {solicitudCredito.status.value}
                </Label>,
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <AttachMoneyOutlined /> Monto </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    $ {Numero.formatoComas(solicitudCredito.monto.value)}
                </Label>,
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <PriceCheckOutlined /> Aprobado </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    $ {Numero.formatoComas(solicitudCredito.montoAprobado)}
                </Label>,
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <EditCalendarOutlined /> Plazo </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <>
                    <Label
                        style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer" }}
                        data-tooltip-id={`plazo-${cliente?.IdCliente}`}
                        onDoubleClick={() => {
                            setSolicitudCredito(solicitudCredito);
                            setIsOpenModalSolicitud(true);
                        }}
                    >
                        {solicitudCredito.plazo.value.replace(/\s*\(.*?\)/g, "")}
                    </Label>
                    <Tooltip
                        id={`plazo-${cliente?.IdCliente}`}
                        place="right-start"
                    >
                        <p style={{ fontSize: 14 }} >
                            {solicitudCredito.plazo.value}
                        </p>
                    </Tooltip>
                </>,
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <PaymentOutlined /> Pago </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    {solicitudCredito.formaPago.value}
                </Label>,
        },

        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} >  </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <>
                    <IconButton
                        style={{ color: colors.rojo, marginRight: 5 }}
                        onClick={() => {
                            setIsOpenModalEliniarSolicitud(true);
                            setSolicitudCredito(solicitudCredito);
                        }}
                    >
                        <DeleteOutlineOutlined />
                    </IconButton>
                    <IconButton
                        style={{ color: colors.secundario }}
                        onClick={async () => {
                            setSolicitudCredito(solicitudCredito);
                            const response: Response = await ClienteService.obtenerPorId(cliente?.IdCliente ?? 0);
                            const clienteData: Cliente = response.data.value;
                            setClienteData(clienteData);
                            setIsOpenModalPDF(true);
                        }}
                    >
                        {/* < PictureAsPdfOutlined /> */}
                        <img
                            src={icoPDF}
                            alt="No imagen"
                            style={{ height: 20 }}
                        />
                    </IconButton>
                </>,
        },
    ]

    return (
        <>
            <ToastContainer position="bottom-right" autoClose={5000} limit={3} />
            <main style={{ width: "100%", minHeight: "100vh", /*height:/* "100vh", maxHeight: "auto",*/ backgroundColor: colors.blanco }} >
                <section style={{ marginLeft: data.isDesktop ? 80 : 0, position: "relative" }} >
                    <Block height={"3vh"} />

                    <Row style={{ marginRight: 0, marginLeft: 0, }} >
                        <Col>
                            <Label style={{ fontSize: 24, fontWeight: "bold", color: colors.negro }} >
                                Clientes Registrados <br />
                                <span style={{ fontWeight: "normal", fontSize: 14 }} >Administra y consulta la informacion de todos los clientes</span>
                            </Label>
                        </Col>

                    </Row>

                    <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10, width: "100%" }} >

                        <Col>
                            <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                <InputGroup >

                                    <Input
                                        id="login.username"
                                        name="username"
                                        type="text"
                                        placeholder=" "
                                        value={texto}
                                        style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            setTexto(value);
                                        }}
                                        onKeyDown={({ key }: KeyboardEvent<HTMLInputElement>) => {
                                            if (key === "Enter") clientesListar();
                                        }}
                                    />
                                    <Label style={{ marginLeft: 0 }} >Nombre(s), apellidos</Label>
                                    <InputGroupText
                                        data-tooltip-id="tooltip-search-cliente"
                                        style={{ cursor: "pointer", color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0 }}
                                        onClick={() => clientesListar()}
                                    >
                                        <Search />
                                    </InputGroupText>
                                    <Tooltip
                                        id="tooltip-search-cliente"
                                        place="right-start"
                                    >
                                        <p>
                                            Buscar clientes
                                        </p>
                                    </Tooltip>
                                </InputGroup>
                            </FormGroup>
                        </Col>

                        <Col style={{ textAlign: "right", }} >
                            <IconButton
                                style={{ marginRight: 10, color: colors.secundario, marginTop: 20 }}
                                data-tooltip-id="tooltip-refresh-cliente"
                                onClick={() => {
                                    clientesListar();
                                }}
                            >
                                <Cached />
                            </IconButton>
                            <Tooltip
                                id="tooltip-refresh-cliente"
                                place="right-start"
                            >
                                <p>
                                    Listar clientes
                                </p>
                            </Tooltip>
                            <IconButton
                                style={{ marginRight: 10, color: colors.secundario, marginTop: 20 }}
                                data-tooltip-id="tooltip-add-cliente"
                                onClick={() => {
                                    changeIndexPage(1)
                                }}
                            >
                                <Add />
                            </IconButton>
                            <Tooltip
                                id="tooltip-add-cliente"
                                place="right-start"
                            >
                                <p>
                                    Agregar un nuevo cliente
                                </p>
                            </Tooltip>
                        </Col>

                    </Row>

                    <Row style={{ marginLeft: 0, marginRight: 0, marginTop: 10 }} >
                        <Col  >
                            {
                                arrayCliente.length === 0 ?
                                    <center>
                                        <Label style={{ fontWeight: "bold", fontSize: 22, marginTop: 100 }} >
                                            No se han registrado clientes
                                        </Label>
                                    </center>
                                    :
                                    <DataTable
                                        columns={columnasCliente}
                                        data={arrayCliente}
                                        highlightOnHover
                                        customStyles={{
                                            rows: {
                                                highlightOnHoverStyle: {
                                                    backgroundColor: "#eeeeee",
                                                    transition: "0.3s",
                                                    cursor: "pointer"
                                                },
                                            },
                                        }}
                                        onRowClicked={(row) => {
                                            const now = new Date().getTime();
                                            if (now - lastClickTime < 300) verDatosCliente(row);
                                            lastClickTime = now;
                                        }}
                                    />
                            }

                        </Col>
                    </Row>

                </section>
            </main>

            <Modal
                isOpen={isOpenModalMapa}
                style={{ fontFamily: '"Fira Code", monospace', minWidth: "70%" }}
                fullscreen={data.isMovil}
            >
                <ModalHeader
                    style={{ backgroundColor: colors.secundario }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ backgroundColor: colors.secundario, color: colors.blanco }}
                                onClick={() => setIsOpenModalMapa(false)}
                            >
                                <Close />
                            </IconButton>
                        </Col>
                    }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <Map style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                    Ubicacion (Google maps)
                                </span>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody style={{ minHeight: data.isDesktop ? "65vh" : "", height: data.isDesktop ? "65vh" : "", maxHeight: data.isDesktop ? "65vh" : "", overflowY: "hidden" }} >

                    <Row style={{ height: "95%" }}>
                        <Col style={{ textAlign: "center" }} >
                            {
                                ubicacion?.latitud === 0 && ubicacion.longitud === 0 ?

                                    <img
                                        src={imgMapa}
                                        alt="No imagen"
                                        style={{ width: "30%", height: 350 }}
                                    />
                                    :
                                    <iframe
                                        width="100%"
                                        height="95%"
                                        title="Google maps"
                                        style={{ border: 0 }}
                                        loading="lazy"
                                        allowFullScreen
                                        src={`https://www.google.com/maps?q=${ubicacion?.latitud},${ubicacion?.longitud}&z=15&output=embed`}
                                    />
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ textAlign: ubicacion?.latitud === 0 && ubicacion.longitud === 0 ? "center" : "left" }} >
                            {
                                ubicacion?.latitud === 0 && ubicacion.longitud === 0 ?
                                    <Label>
                                        No hay ubicacion registrada para este cliente
                                    </Label>
                                    :
                                    <Label>
                                        Latitud: {ubicacion?.latitud}, Longitud: {ubicacion?.longitud}
                                    </Label>
                            }

                        </Col>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ width: 150, backgroundColor: colors.secundario, fontWeight: "bold", boxShadow: "none" }}
                        onClick={() => setIsOpenModalMapa(false)}
                    >
                        <CloseFullscreen /> Cerrar
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal
                isOpen={isOpenModalSolicitudError}
                centered
                fullscreen={data.isMovil}
                style={{ fontFamily: '"Fira Code", monospace', minWidth: "60%" }}
                onOpened={() => { }}
            >
                <ModalHeader
                    style={{ backgroundColor: colors.secundario }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ backgroundColor: colors.secundario, color: colors.blanco }}
                                onClick={() => setIsOpenModalSolicitudError(false)}
                            >
                                <Close />
                            </IconButton>
                        </Col>
                    }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <WarningAmberOutlined style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                    Atencion
                                </span>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody style={{ minHeight: data.isDesktop ? "60vh" : "", height: data.isDesktop ? "60vh" : "", maxHeight: data.isDesktop ? "60vh" : "", overflowY: "scroll" }} >
                    <Row>
                        <Col style={{ minWidth: "100%", width: "100%", maxWidth: "100%", backgroundColor: "transparent" }} >
                            <Row style={{ width: "100%", marginRight: 0, marginLeft: 0 }} >
                                <Label style={{ color: colors.rojo, fontWeight: "bold", fontSize: 18 }} >
                                    <ErrorOutlined style={{ marginRight: 10 }} />
                                    No se guardo la solicitud de credito
                                    <br />
                                    <span style={{ fontSize: 16, fontWeight: "normal", marginLeft: 30 }} >Verifica la siguiente informacion antes de continuar</span>
                                </Label>
                            </Row>
                            <Row style={{ width: "100%", marginRight: 0, marginLeft: 0 }} >
                                <Block height={"1px"} backgroundColor={colors.secundario} />
                            </Row>
                            {
                                indexDatoFaltanteSolicitud.find((item) => item.index === "IdTipo")?.value &&
                                <>
                                    <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                        <Col style={{ maxWidth: "10%" }} >
                                            <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                                <Groups2Outlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                            </div>
                                        </Col>
                                        <Col style={{ maxWidth: "90%" }} >
                                            <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                                Tipo de Solicitud de Credito
                                                <br />
                                                <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que este seleccionado el tipo de solicitud </span>
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            }
                            {
                                indexDatoFaltanteSolicitud.find((item) => item.index === "IdStatus")?.value &&
                                <>
                                    <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                        <Col style={{ maxWidth: "10%" }} >
                                            <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                                <RecommendOutlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                            </div>
                                        </Col>
                                        <Col style={{ maxWidth: "90%" }} >
                                            <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                                Estatus de la Solicitud de Credito
                                                <br />
                                                <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que este seleccionado el estatus de la solicitud </span>
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            }
                            {
                                indexDatoFaltanteSolicitud.find((item) => item.index === "IdMonto")?.value &&
                                <>
                                    <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                        <Col style={{ maxWidth: "10%" }} >
                                            <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                                <AttachMoneyOutlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                            </div>
                                        </Col>
                                        <Col style={{ maxWidth: "90%" }} >
                                            <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                                Monto Solicitado
                                                <br />
                                                <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que este seleccionado el monto solicitado </span>
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            }
                            {
                                indexDatoFaltanteSolicitud.find((item) => item.index === "IdPlazo")?.value &&
                                <>
                                    <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                        <Col style={{ maxWidth: "10%" }} >
                                            <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                                <CalendarTodayOutlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                            </div>
                                        </Col>
                                        <Col style={{ maxWidth: "90%" }} >
                                            <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                                Plazo del Credito
                                                <br />
                                                <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que este seleccionado el plazo del credito </span>
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            }
                            {
                                indexDatoFaltanteSolicitud.find((item) => item.index === "IdFormaPago")?.value &&
                                <>
                                    <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                        <Col style={{ maxWidth: "10%" }} >
                                            <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                                <PaymentOutlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                            </div>
                                        </Col>
                                        <Col style={{ maxWidth: "90%" }} >
                                            <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                                Forma de Pago
                                                <br />
                                                <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que este seleccionado la forma de pago </span>
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            }
                        </Col>

                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ width: 150, backgroundColor: colors.secundario, fontWeight: "bold", boxShadow: "none" }}
                        onClick={() => setIsOpenModalSolicitudError(false)}
                    >
                        <CloseFullscreen /> Entendido
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal
                isOpen={isOpenModelPDF}
                fullscreen
                style={{ fontFamily: '"Fira Code", monospace', }}
                onOpened={() => { }}
            >
                <ModalHeader
                    style={{ backgroundColor: "#282828", padding: 5 }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ color: colors.blanco, marginRight: 15 }}
                                onClick={async () => {

                                    const blob = await pdf(
                                        <SolicitudCreditoPdf
                                            cliente={clienteData}
                                            solicitudCredito={solicitudCredito}
                                            operacionesMontos={operacionesMontos}
                                            operacionesNumeros={operacionesNumeros}
                                            operacionesFrecuencias={operacionesFrecuencias}
                                        />
                                    ).toBlob();

                                    const url = URL.createObjectURL(blob);

                                    const link = document.createElement("a");
                                    link.href = url;
                                    link.download = `Solicitud Credito de ${cliente?.nombres} ${cliente?.paterno} ${cliente?.materno}.pdf`;
                                    link.click();

                                }}
                            >
                                <DownloadOutlined />
                            </IconButton>
                            <IconButton
                                style={{ color: colors.blanco }}
                                onClick={() => {
                                    setIsOpenModalPDF(false);
                                }}
                            >
                                <Close />
                            </IconButton>
                        </Col>
                    }
                >

                </ModalHeader>
                <ModalBody style={{ padding: 0, overflowY: "hidden" }} >
                    <PDFViewer width="100%" height="100%"  >
                        <SolicitudCreditoPdf
                            cliente={clienteData}
                            solicitudCredito={solicitudCredito}
                            operacionesMontos={operacionesMontos}
                            operacionesNumeros={operacionesNumeros}
                            operacionesFrecuencias={operacionesFrecuencias}
                        />
                    </PDFViewer>
                </ModalBody>
                {/* <ModalFooter>

                </ModalFooter> */}
            </Modal>

            <Modal
                isOpen={isOpenModalEliniarSolicitud}
                centered
                fullscreen={data.isMovil}
                style={{ fontFamily: '"Fira Code", monospace', minWidth: "30%" }}
                onOpened={() => {
                    TiempoTool.sleep(30).then(() => {
                        setIsOpenModalEliniarSolicitud(false);
                        setSolicitudCredito(objectSolicitud);
                    });
                }}
            >
                <ModalHeader
                    style={{
                        backgroundColor: "#1f4b82",
                        padding: "12px 20px",
                        borderBottom: "none"
                    }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ color: colors.blanco }}
                                onClick={() => {
                                    setIsOpenModalEliniarSolicitud(false);
                                }}
                            >
                                <Close />
                            </IconButton>
                        </Col>
                    }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <WarningAmberOutlined style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                    ¡Atencion!
                                </span>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <center>
                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                            <Col  >
                                <div style={{ height: 70, width: 70, backgroundColor: "#FCEDED", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                    <AutoDeleteOutlined style={{ height: 50, width: 50, color: "#D83F37" }} />
                                </div>
                            </Col>
                        </Row>
                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10, fontSize: 16 }} >
                            <Col style={{ textAlign: "center" }} >
                                <Label style={{ fontWeight: "bold" }} >
                                    Eliminacion de Solicitud de Credito
                                </Label>
                            </Col>
                        </Row>
                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10, fontSize: 14 }} >
                            <Col style={{ textAlign: "center" }} >
                                <p>
                                    Una vez eliminada la solicitud de credito
                                    no se podran recuperar los datos
                                </p>
                            </Col>
                        </Row>
                    </center>
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ width: "auto", backgroundColor: colors.blanco, borderColor: colors.rojo, fontWeight: "bold", boxShadow: "none", marginRight: 10, color: colors.rojo }}
                        onClick={() => { solicitudCreditoEliminar(); }}
                    >
                        <DeleteOutlineOutlined />  Eliminar
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal
                isOpen={isOpenModalSolicitud}
                centered
                fullscreen={data.isMovil}
                style={{ fontFamily: '"Fira Code", monospace', minWidth: modal === "Cliente" ? "85%" : "70%", transition: "min-width 1s ease" }}
                onOpened={() => {
                    solicitudCreditoListar(cliente?.IdCliente ?? 0);
                }}
                onClosed={() => {
                    setArraysolicitudCredito([]);
                }}
            >
                <ModalHeader
                    style={{ backgroundColor: colors.secundario }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            {
                                modal === "Solicitud" &&
                                <IconButton
                                    style={{ backgroundColor: colors.secundario, color: colors.blanco, marginRight: 10 }}
                                    onClick={() => setModal("Cliente")}
                                >
                                    <ArrowBack />
                                </IconButton>
                            }

                            <IconButton
                                style={{ backgroundColor: colors.secundario, color: colors.blanco }}
                                onClick={() => {
                                    setIsOpenModalSolicitud(false);
                                    TiempoTool.sleep(0.750).then(() => {
                                        setModal("Cliente");
                                    });
                                }}
                            >
                                <Close />
                            </IconButton>

                        </Col>
                    }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <AssignmentOutlined style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                {
                                    modal === "Cliente" &&
                                    <Fade duration={1000} >
                                        <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                            Solicitudes de Credito
                                        </span>
                                    </Fade>
                                }
                                {
                                    modal === "Solicitud" &&
                                    <Fade duration={1000} >
                                        <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                            Datos de la Solicitud de Credito
                                        </span>
                                    </Fade>
                                }

                                <small style={{ color: colors.blanco, fontSize: 13 }} >
                                    {cliente?.nombres} {cliente?.paterno} {cliente?.materno}
                                </small>


                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody style={{ minHeight: data.isDesktop ? "65vh" : "", height: data.isDesktop ? "65vh" : "", maxHeight: data.isDesktop ? "65vh" : "", overflowY: "scroll" }} >
                    {
                        modal === "Cliente" &&
                        <Fade duration={1000} >
                            <Row>
                                <Col>
                                    <Label style={{ fontSize: 16, fontWeight: "bold" }} >
                                        Solicitudes de Credito Registrados
                                    </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <DataTable
                                        columns={columnaSolicitudCredito}
                                        data={arraySolicitudCredito}
                                        highlightOnHover
                                        customStyles={{
                                            rows: {
                                                highlightOnHoverStyle: {
                                                    backgroundColor: "#eeeeee",
                                                    transition: "0.3s",
                                                    cursor: "pointer"
                                                },
                                            },
                                        }}
                                        onRowClicked={(row) => {
                                            const now = new Date().getTime();
                                            if (now - lastClickTime < 300) {
                                                setSolicitudCredito(row);
                                                setModal("Solicitud")
                                            };
                                            lastClickTime = now;
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Fade>
                    }
                    {
                        modal === "Solicitud" &&
                        <Fade duration={1000} >
                            <Row style={{ marginRight: 0, marginLeft: 0, width: "100%" }} >
                                <Col>
                                    <Card >
                                        <CardHeader>
                                            <Label style={{ color: colors.secundario, fontWeight: "bold" }} >
                                                <CalendarTodayOutlined /> Datos de la solicitud
                                            </Label>
                                        </CardHeader>
                                        <CardBody>
                                            <Row>
                                                <Col style={{ minWidth: data.isDesktop ? "33%" : "100%", width: data.isDesktop ? "33" : "100%", maxWidth: data.isDesktop ? "33%" : "100%", }} >
                                                    <FormGroup className={`google-input ${clienteData.fechaEntrevista ? "has-value" : ""}`}>
                                                        <InputGroup>
                                                            <Input
                                                                type="date"
                                                                value={clienteData.fechaEntrevista}
                                                                style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent", cursor: "pointer" }}
                                                                onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                                    setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, fechaCreacion: value }));
                                                                }}
                                                            />
                                                            <Label>
                                                                Fecha
                                                            </Label>
                                                        </InputGroup>
                                                        <span>
                                                            {FechaTool.convertirLetras(clienteData.fechaEntrevista)}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                                <Col style={{ minWidth: data.isDesktop ? "33%" : "100%", width: data.isDesktop ? "33" : "100%", maxWidth: data.isDesktop ? "33%" : "100%" }} >
                                                    <FormControl fullWidth style={{ marginTop: 10 }} >
                                                        <InputLabel
                                                            id="demo-simple-select-label"
                                                            sx={{
                                                                color: colors.secundario,
                                                                '&.MuiInputLabel-shrink': {
                                                                    fontSize: '1.2rem',
                                                                    color: colors.secundario
                                                                },
                                                            }}
                                                        >
                                                            Tipo
                                                        </InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            style={{ borderRightColor: "transparent" }}
                                                            sx={SelectStyle.sx}
                                                            value={solicitudCredito.tipo.IdTipo.toString()}
                                                            onChange={({ target: { value } }: SelectChangeEvent) => {
                                                                setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, tipo: { ...prev.tipo, IdTipo: Number(value) } }));
                                                            }}
                                                        >
                                                            <MenuItem value={0}> Selecciona una opcion </MenuItem>
                                                            {
                                                                arrayTipo.map((item: Value) => {
                                                                    return <MenuItem value={item.Id}> {item.value} </MenuItem>
                                                                })
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Col>
                                                <Col style={{ minWidth: data.isDesktop ? "33%" : "100%", width: data.isDesktop ? "33" : "100%", maxWidth: data.isDesktop ? "33%" : "100%" }} >
                                                    <FormControl fullWidth style={{ marginTop: 10 }} >
                                                        <InputLabel
                                                            id="demo-simple-select-label"
                                                            sx={{
                                                                color: colors.secundario,
                                                                '&.MuiInputLabel-shrink': {
                                                                    fontSize: '1.2rem',
                                                                    color: colors.secundario
                                                                },
                                                            }}
                                                        >
                                                            Estatus
                                                        </InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            style={{ borderRightColor: "transparent" }}
                                                            sx={SelectStyle.sx}
                                                            value={solicitudCredito.status.IdStatus.toString()}
                                                            onChange={({ target: { value } }: SelectChangeEvent) => {
                                                                setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, status: { ...prev.status, IdStatus: Number(value) } }));
                                                            }}
                                                        >
                                                            <MenuItem value={0}> Selecciona una opcion </MenuItem>
                                                            {
                                                                arrayStatus.map((item: Value) => {
                                                                    return <MenuItem value={item.Id}> {item.value} </MenuItem>
                                                                })
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <Row style={{ marginRight: 0, marginLeft: 0, width: "100%", marginTop: 20 }} >
                                <Col>
                                    <Card>
                                        <CardHeader>
                                            <Label style={{ color: colors.secundario, fontWeight: "bold" }} >
                                                <CreditCard /> Condiciones del credito
                                            </Label>
                                        </CardHeader>
                                        <CardBody>
                                            <Row>
                                                <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                                    <FormControl fullWidth style={{ marginTop: 10 }} >
                                                        <InputLabel
                                                            id="demo-simple-select-label"
                                                            sx={{
                                                                color: colors.secundario,
                                                                '&.MuiInputLabel-shrink': {
                                                                    fontSize: '1.2rem',
                                                                    color: colors.secundario
                                                                },
                                                            }}
                                                        >
                                                            Monto
                                                        </InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            style={{ borderRightColor: "transparent" }}
                                                            sx={SelectStyle.sx}
                                                            value={solicitudCredito.monto.IdMonto.toString()}
                                                            onChange={({ target: { value } }: SelectChangeEvent) => {
                                                                setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, monto: { ...prev.monto, IdMonto: Number(value) } }));
                                                            }}
                                                        >
                                                            <MenuItem value={0}> Selecciona una opcion </MenuItem>
                                                            {
                                                                arrayMonto.map((item: Value) => {
                                                                    return <MenuItem value={item.Id}>$ {Numero.formatoComas(item.value)} </MenuItem>
                                                                })
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Col>
                                                <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                                    <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                                        <InputGroup >
                                                            <InputGroupText style={{ borderColor: colors.secundario }} >
                                                                $
                                                            </InputGroupText>
                                                            <Input
                                                                type="text"
                                                                placeholder=" "
                                                                value={solicitudCredito.montoAprobado}
                                                                style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                                onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {

                                                                    value = Numero.formatoComas(Numero.soloNumeros(value, true));
                                                                    setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, montoAprobado: value }));

                                                                }}
                                                            />
                                                            <Label style={{ marginLeft: 0 }} >Monto aprobado</Label>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                                <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                                    <FormControl fullWidth style={{ marginTop: 10 }} >
                                                        <InputLabel
                                                            id="demo-simple-select-label"
                                                            sx={{
                                                                color: colors.secundario,
                                                                '&.MuiInputLabel-shrink': {
                                                                    fontSize: '1.2rem',
                                                                    color: colors.secundario
                                                                },
                                                            }}
                                                        >
                                                            Plazo
                                                        </InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            style={{ borderRightColor: "transparent" }}
                                                            sx={SelectStyle.sx}
                                                            value={solicitudCredito.plazo.IdPlazo.toString()}
                                                            onChange={({ target: { value } }: SelectChangeEvent) => {
                                                                setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, plazo: { ...prev.plazo, IdPlazo: Number(value) } }));
                                                            }}
                                                        >
                                                            <MenuItem value={0}> Selecciona una opcion </MenuItem>
                                                            {
                                                                arrayPlazo.map((item: Value) => {
                                                                    return <MenuItem value={item.Id}> {item.value} </MenuItem>
                                                                })
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Col>
                                                <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                                    <FormControl fullWidth style={{ marginTop: 10 }} >
                                                        <InputLabel
                                                            id="demo-simple-select-label"
                                                            sx={{
                                                                color: colors.secundario,
                                                                '&.MuiInputLabel-shrink': {
                                                                    fontSize: '1.2rem',
                                                                    color: colors.secundario
                                                                },
                                                            }}
                                                        >
                                                            Forma de Pago
                                                        </InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            style={{ borderRightColor: "transparent" }}
                                                            sx={SelectStyle.sx}
                                                            value={solicitudCredito.formaPago.IdFormaPago.toString()}
                                                            onChange={({ target: { value } }: SelectChangeEvent) => {
                                                                setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, formaPago: { ...prev.formaPago, IdFormaPago: Number(value) } }));
                                                            }}
                                                        >
                                                            <MenuItem value={0}> Selecciona una opcion </MenuItem>
                                                            {
                                                                arrayFormaPago.map((item: Value) => {
                                                                    return <MenuItem value={item.Id}> {item.value} </MenuItem>
                                                                })
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <Row style={{ marginRight: 0, marginLeft: 0, width: "100%", marginTop: 20 }} >
                                <Col>
                                    <Card>
                                        <CardHeader>
                                            <Label style={{ color: colors.secundario, fontWeight: "bold" }} >
                                                <Chat /> Observaciones
                                            </Label>
                                        </CardHeader>
                                        <CardBody>
                                            <Row>
                                                <Col>
                                                    <FormControl fullWidth style={{ marginTop: 10, height: "80%" }} >
                                                        <Input
                                                            className="no-focus"
                                                            style={{ height: 150, minHeight: 150, maxHeight: 150, boxShadow: "none", borderColor: colors.secundario }}
                                                            type="textarea"
                                                            value={solicitudCredito.observaciones}
                                                            onChange={({ target: { value } }: SelectChangeEvent) => {
                                                                if (value.length <= 500) {
                                                                    setSolicitudCredito({ ...solicitudCredito, observaciones: value });
                                                                }
                                                            }}
                                                        >
                                                        </Input>
                                                        <span> {solicitudCredito.observaciones.length}/500 </span>
                                                    </FormControl>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            {
                                data.isMovil &&

                                <Row>
                                    <Col style={{ textAlign: "left" }} >
                                        <Row>
                                            <Label>
                                                Asesor: {solicitudCredito.usuario.nombre}
                                            </Label>
                                        </Row>
                                        <Row>
                                            <Label>
                                                Fecha y Hora: {FechaTool.convertirLetras(solicitudCredito.fechaModificacion).split(",")[0]} {FechaTool.formato(solicitudCredito.fechaModificacion)}, {TiempoTool.convertTimeTo12HourFormat(solicitudCredito.horaModificacion)}
                                            </Label>
                                        </Row>
                                    </Col>
                                </Row>
                            }

                        </Fade>
                    }
                </ModalBody>
                <ModalFooter>

                    {
                        modal === "Solicitud" &&
                        <Row style={{ minWidth: "100%", width: "100%", maxWidth: "100%" }} >
                            {
                                (solicitudCredito.usuario.IdUsuario !== 0 && data.isDesktop) &&
                                <Col style={{ textAlign: "left" }} >
                                    <Row>
                                        <Label>
                                            Asesor: {solicitudCredito.usuario.nombre}
                                        </Label>
                                    </Row>
                                    <Row>
                                        <Label>
                                            Fecha y Hora: {FechaTool.convertirLetras(solicitudCredito.fechaModificacion).split(",")[0]} {FechaTool.formato(solicitudCredito.fechaModificacion)}, {TiempoTool.convertTimeTo12HourFormat(solicitudCredito.horaModificacion)}
                                        </Label>
                                    </Row>
                                </Col>
                            }

                            <Col style={{ textAlign: "right" }} >
                                {
                                    solicitudCredito.IdSolicitudCredito !== 0 &&
                                    <Button
                                        style={{ width: data.isDesktop ? 150 : "auto", backgroundColor: colors.blanco, borderColor: colors.rojo, fontWeight: "bold", boxShadow: "none", marginRight: 10, color: colors.rojo }}
                                        onClick={() => {
                                            setIsOpenModalEliniarSolicitud(true);
                                            setSolicitudCredito(solicitudCredito);
                                        }}
                                    >
                                        <DeleteOutlineOutlined /> {data.isDesktop ? "Eliminar" : ""}
                                    </Button>
                                }
                                <Button
                                    style={{ width: data.isDesktop ? 150 : "auto", backgroundColor: colors.blanco, fontWeight: "bold", boxShadow: "none", marginRight: 10, color: colors.secundario, borderRadius: colors.secundario }}
                                    onClick={() => setSolicitudCredito({ ...objectSolicitud, IdCliente: cliente?.IdCliente ?? 0 })}
                                >
                                    <PostAddOutlined /> {data.isDesktop ? "Nuevo" : ""}
                                </Button>
                                <Button
                                    style={{ width: data.isDesktop ? 150 : "auto", backgroundColor: colors.secundario, fontWeight: "bold", boxShadow: "none" }}
                                    onClick={() => solicitudCreditoGuardar()}
                                >
                                    <SaveOutlined /> {data.isDesktop ? "Guardar" : ""}
                                </Button>
                            </Col>
                        </Row>
                    }
                    {
                        modal === "Cliente" &&
                        <Button
                            style={{ width: 150, backgroundColor: colors.secundario, fontWeight: "bold", boxShadow: "none" }}
                            onClick={() => setIsOpenModalSolicitud(false)}
                        >
                            <CloseFullscreen /> Cerrar
                        </Button>
                    }

                </ModalFooter>
            </Modal>

        </>
    );

};

export default ClienteBuscar;